export enum DateFormat {
  /**
   * `format`: 'dd-mm-yyyy'
   */
  ShortDate = 'shortDate',
  /**
   * `format`: 'dd-mm-yyyy, hh:mm:ss'
   */
  LongDate = 'longDate',
}

const dateFormatStrings: Record<DateFormat, string> = {
  [DateFormat.ShortDate]: 'dd/mm/yyyy',
  [DateFormat.LongDate]: 'dd/mm/yyyy, hh:mm:ss',
};

/**
 * Formats a date in the specified format from Enum DateFormat.
 * @param {string} inputDate - The input date as a string.
 * @param {DateFormat} format - The format in which the date should be formatted. {@link DateFormat}
 * @returns {string} The formatted date.
 */

export const formatDate = (inputDate: string, format: DateFormat): string => {
  const date = new Date(inputDate);
  const day = date.getUTCDate();
  const month = date.getUTCMonth() + 1;
  const year = date.getUTCFullYear();
  const hours = date.getUTCHours();
  const minutes = date.getUTCMinutes();
  const seconds = date.getUTCSeconds();

  let formattedFormat = dateFormatStrings[format];
  formattedFormat = formattedFormat.replace('dd', day.toString().padStart(2, '0'));
  formattedFormat = formattedFormat.replace('mm', month.toString().padStart(2, '0'));
  formattedFormat = formattedFormat.replace('yyyy', year.toString());
  formattedFormat = formattedFormat.replace('hh', hours.toString().padStart(2, '0'));
  formattedFormat = formattedFormat.replace('mm', minutes.toString().padStart(2, '0'));
  formattedFormat = formattedFormat.replace('ss', seconds.toString().padStart(2, '0'));

  return formattedFormat;
};
